export const RESET = 'EXSBITEMSCATEGORY_LIST_RESET'
export const SET_ITEMS = 'EXSBITEMSCATEGORY_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBITEMSCATEGORY_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBITEMSCATEGORY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBITEMSCATEGORY_LIST_TOGGLE_LOADING'
